/* Rquiere de mixin.js */

var inventoryTemplateDetail = {
	data() {
		return {
			listInventoryTemplateDetail: [],
			loadingInventoryTemplateDetails: false,
			paginationInventoryTemplateDetail: [],
			objectInventoryTemplateDetail: {
				exist: 0,
				id: 0,
				inventory_template_id: 0,
				product_id: 0,
				product: {},
				store_rack_side_row_column_id: 0,
				storeRackSideRowColumn: {},
				count_1: null,
				updated_at_1: null,
				count_2: null,
				updated_at_2: null,
				count_3: null,
				updated_at_3: null,
				count_4: null,
				updated_at_4: null,
				count_end: null,
				updated_at_end: null,
				created_at: null,
				updated_at: null,
			},
			qRowsInventoryTemplateDetail: 25,
			updatingInventoryTemplateDetail: false,
			savingInventoryTemplateDetail: false,
			searchingInventoryTemplateDetail: false,
			searchInventoryTemplateDetail: '',
			onlyDifference: false,
			unconfirmed: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListProducts(newInventoryTemplateDetail) {
			this.listInventoryTemplateDetail.push(newInventoryTemplateDetail)
		},
		clearObjectInventoryTemplateDetail() {
			this.objectInventoryTemplateDetail.exist = 0
			this.objectInventoryTemplateDetail.id = 0
			this.objectInventoryTemplateDetail.inventory_template_id = 0
			this.objectInventoryTemplateDetail.product_id = 0
			this.objectInventoryTemplateDetail.product = {}
			this.objectInventoryTemplateDetail.store_rack_side_row_column_id = 0
			this.objectInventoryTemplateDetail.store_rack_side_row_column = {}
			this.objectInventoryTemplateDetail.count_1 = null
			this.objectInventoryTemplateDetail.updated_at_1 = null
			this.objectInventoryTemplateDetail.count_2 = null
			this.objectInventoryTemplateDetail.updated_at_2 = null
			this.objectInventoryTemplateDetail.count_3 = null
			this.objectInventoryTemplateDetail.updated_at_3 = null
			this.objectInventoryTemplateDetail.count_4 = null
			this.objectInventoryTemplateDetail.updated_at_4 = null
			this.objectInventoryTemplateDetail.count_end = null
			this.objectInventoryTemplateDetail.updated_at_end = null
			this.objectInventoryTemplateDetail.created_at = null
			this.objectInventoryTemplateDetail.updated_at = null
		},
		addFromProductStoreRackSideRowColumn(productStoreRackSideRowColumn) {
			let inventoryTemplateDetail = {
				id: 0,
				inventory_template_id: 0,
				product_id: productStoreRackSideRowColumn.product_id,
				product: productStoreRackSideRowColumn.product,
				store_rack_side_row_column_id: productStoreRackSideRowColumn.store_rack_side_row_column_id,
				store_rack_side_row_column: productStoreRackSideRowColumn.store_rack_side_row_column,
				count_1: null,
				updated_at_1: null,
				count_2: null,
				updated_at_2: null,
				count_3: null,
				updated_at_3: null,
				count_4: null,
				updated_at_4: null,
				count_end: null,
				updated_at_end: null,
				quantity: productStoreRackSideRowColumn.quantity,
				created_at: null,
				created_at: null,
			}
			this.listInventoryTemplateDetail.push(inventoryTemplateDetail)
		},
		getNameInventoryTemplateFromDetail(item) {
			return item.inventory_template.name
		},
		getLocationInventoryTemplateFromDetail(item) {
			let name = item.store_rack_side_row_column.store.name
			name += ' ' + item.store_rack_side_row_column.store_rack.name
			name += ' ' + item.store_rack_side_row_column.store_rack_side.name
			name += ' ' + item.store_rack_side_row_column.name
			name += ' ' + item.store_rack_side_row_column.store_rack_side_row.name
			return name
		},
		getAllInventoryTemplateDetailForInventoryId(inventoryId, page = 1) {
			this.searchingInventoryTemplateDetail = true
			this.listInventoryTemplateDetail = []
			this.paginationInventoryTemplateDetail = []
			let param = '?page=' + page + '&search=' + this.searchInventoryTemplateDetail + '&onlyDifference=' + this.onlyDifference + '&unconfirmed=' + this.unconfirmed
			let url = this.getApiBackend + 'inventory/' + inventoryId + '/templateDetails' + param
			this.axiosActionIS(url, 'GET', 'getAllInventoryTemplateDetailResult')
		},
		getAllInventoryTemplateDetailResult(response) {
			this.searchingInventoryTemplateDetail = false
			if (response.data.success == true) {
				this.listInventoryTemplateDetail = response.data.data
				this.paginationInventoryTemplateDetail = response.data.paginate
			}
			this.getAllInventoryTemplateDetailResultLocal(response)
		},
		getAllInventoryTemplateDetailResultLocal(response) {
			console.log('getAllInventoryTemplateDetailResult no desarrollado', response)
		},
		saveObjectInventoryTemplateDetail() {
			this.savingInventoryTemplateDetail = true
			let url = this.getApiBackend + 'inventoryTemplateDetail/register'
			console.log(url, this.objectInventoryTemplateDetail)
			this.axiosActionIS(url, 'POST', 'saveObjectInventoryTemplateDetailResult', this.objectInventoryTemplateDetail)
		},
		saveObjectInventoryTemplateDetailResult(response) {
			this.savingInventoryTemplateDetail = false
			if (response.data.success == true) {
				this.setObjectInventoryTemplateDetail(response.data.data)
			}
			this.saveObjectInventoryTemplateDetailResultLocal(response)
		},
		saveObjectInventoryTemplateDetailResultLocal(response) {
			console.log('saveObjectInventoryTemplateDetailResultLocal no desarrollado', response)
		},
		setObjectInventoryTemplateDetail(item) {
			this.clearObjectInventoryTemplateDetail()
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectInventoryTemplateDetail[property] = newItem[property]
			}
		},
		updateCount(index, item) {
			let value = String(item['count_' + index])
			if (value != null && !isNaN(value) && value != '') {
				this.updateInventoryTemplateDetailForCount(item.id, index, parseInt(value))
			} else {
				if (item['count_' + index] != null && item['count_' + index].trim().length > 0) {
					alert('No se puede actualizar con este dato "' + value + '"')
					item['count_' + index] = ''
				}
			}
		},
		updateInventoryTemplateDetailForCount(id, index, value) {
			this.updatingInventoryTemplateDetail = true
			let url = this.getApiBackend + 'inventoryTemplateDetail/' + id + '/updateCount'
			let data = {
				index: index,
				value: value
			}
			console.log(url, data)
			this.axiosActionIS(url, 'PUT', 'updateInventoryTemplateDetailResult', data)
		},
		updateInventoryTemplateDetailResult(response) {
			this.updatingInventoryTemplateDetail = false
			if (response.data.success == true) {
				if (response.data.message == true) {
					this.setObjectInventoryTemplateDetail(response.data.data)
					this.updateListInventoryTemplateDetail(response.data.data)
				}
			}
			this.updateInventoryTemplateDetailResultLocal(response)
		},
		updateInventoryTemplateDetailResultLocal(response) {
			console.log('updateInventoryTemplateDetailResultLocal no desarrollado', response)
		},
		updateListInventoryTemplateDetail(data) {
			let index = this.listInventoryTemplateDetail.map(e => parseInt(e.id)).indexOf(parseInt(data.id))
			let newItem = Object.create(data)
			if (index > -1) {
				for (const property in newItem) {
					this.listInventoryTemplateDetail[index][property] = newItem[property]
				}
			}
		},
		updateStoreRackModuleWithInventory(inventoryId) {
			this.savingInventoryTemplateDetail = true
			let url = this.getApiBackend + 'inventoryTemplateDetail/updateRack'
			this.axiosActionIS(url, 'POST', 'updateStoreRackModuleWithInventoryResult', { inventoryId: inventoryId })
		},
		updateStoreRackModuleWithInventoryResult(response) {
			this.savingInventoryTemplateDetail = false
			if (response.data.success == true) {
				this.$snotify.info(response.data.message, 'ACTUALIZADO')
			}
			this.updateStoreRackModuleWithInventoryResultLocal(response)
		},
		updateStoreRackModuleWithInventoryResultLocal(response) {
			console.log('updateStoreRackModuleWithInventoryResultLocal no desarrollado', response)
		}
	},
};

export default inventoryTemplateDetail;